import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

// Pop-up da operadora: a gestora DEVOLVEU uma solicitação de finalização manual
// com uma orientação de como resolver a pendência (05/10/2026). Aparece em
// qualquer tela do BPO RH/DP até a operadora marcar "Ciente".
// Backend: core/views_finalizacao_rh.py (GET ?devolvidas=1 / POST acao='ciente').

const API = process.env.REACT_APP_API_BASE;
const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('access')}` });

export default function ModalFinalizacaoDevolvida() {
  const [itens, setItens] = useState([]);
  const [ocupado, setOcupado] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${API}/api/bporh/finalizacao/`, { params: { devolvidas: 1, _: Date.now() }, headers: headers() })
      .then((r) => setItens(r.data.devolvidas || []))
      .catch(() => setItens([]));
  }, []);

  const ciente = (it, abrir) => {
    setOcupado(`${it.tipo}-${it.cliente_id}-${it.convenia_id}`);
    axios.post(`${API}/api/bporh/finalizacao/`,
      { acao: 'ciente', tipo: it.tipo, cliente_id: it.cliente_id, convenia_id: it.convenia_id }, { headers: headers() })
      .catch(() => null)
      .finally(() => {
        setOcupado(null);
        setItens((xs) => xs.filter((x) => x !== it));
        if (abrir) navigate(decodeURIComponent(it.link.split('?')[0]) + '?' + it.link.split('?')[1]);
      });
  };

  if (!itens.length) return null;
  return (
    <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 10004 }}>
      <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content shadow-lg">
          <div className="modal-header bg-white">
            <div>
              <h5 className="modal-title" style={{ color: '#212529' }}>
                <i className="fas fa-reply me-2" style={{ color: '#b58100' }}></i>
                {itens.length === 1 ? 'A gestora devolveu sua solicitação de finalização' : `A gestora devolveu ${itens.length} solicitações de finalização`}
              </h5>
              <div className="small" style={{ color: '#6c757d' }}>
                Ela não finalizou e deixou uma orientação de como resolver a pendência.
              </div>
            </div>
          </div>
          <div className="modal-body">
            {itens.map((it) => {
              const chave = `${it.tipo}-${it.cliente_id}-${it.convenia_id}`;
              return (
                <div key={chave} className="border rounded p-3 mb-3" style={{ background: '#f8f9fb' }}>
                  <div className="d-flex justify-content-between flex-wrap gap-2">
                    <div>
                      <div className="fw-semibold" style={{ color: '#212529' }}>
                        {it.tipo_rotulo.charAt(0).toUpperCase() + it.tipo_rotulo.slice(1)} · {it.colaborador}
                      </div>
                      <div className="small text-muted">{it.cliente} · devolvida por {it.devolvido_por} em {it.devolvido_em}</div>
                    </div>
                  </div>
                  <div className="mt-2 p-2 rounded" style={{ background: '#fff8e6', borderLeft: '3px solid #f1be48', color: '#5c4400' }}>
                    <b>Orientação da gestora:</b> {it.sugestao}
                  </div>
                  {it.motivo && <div className="small mt-2 text-muted">Seu pedido: {it.motivo}</div>}
                  <div className="d-flex justify-content-end gap-2 mt-2">
                    <button type="button" className="btn btn-sm btn-light border" disabled={ocupado === chave} onClick={() => ciente(it, false)}>
                      <i className="fas fa-check me-1"></i>Ciente
                    </button>
                    <button type="button" className="btn btn-sm btn-primary" disabled={ocupado === chave} onClick={() => ciente(it, true)}>
                      <i className="fas fa-up-right-from-square me-1"></i>Ciente e abrir o checklist
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
